<template>
    <modal
        v-model="show"
        :closeable="false"
    >
        <template #header>
            <h2 class="heading text-gray-900">Account Setup</h2>
        </template>
        <div class="text-gray-600">
            You're just two steps away from having your listing active.
        </div>

        <div class="text-gray-600">
            First, please verify your email. If you haven't received a verification email from us, feel free a new email be sent to you.
        </div>

        <template #footer>
            form
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/shared/Modal'

export default {
    data() {
        return {
            show: true
        }
    },
    components: {
        Modal,
    }
}
</script>
